import {createAction, props} from '@ngrx/store';
import {Belegart} from '../../util/belegart.enum';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';
import {ProblemDTO} from '../../openapi/fakturierung-openapi';

export class SendenDialogActions {

    public static open = createAction(
        '[Senden Dialog] Open senden dialog.',
        props<{
          betriebId: string,
          belegId: string,
          belegnummer: string,
          belegart: Belegart,
          empfaengerEmail?: string,
        }>(),
    );

    public static close = createAction(
        '[Senden Dialog] Close senden dialog.',
    );

    public static loadVorschau = createAction(
        '[Senden Dialog] Load Versand-Vorschau.',
        props<{
          betriebId: string,
          belegId: string,
        }>(),
    );

    public static loadVorschauSuccess = createAction(
        '[Senden Dialog] Load Versand-Vorschau success.',
        props<{
          betreff: string,
          body: string,
        }>(),
    );

    public static loadVorschauFailure = createAction(
        '[Senden Dialog] Load Versand-Vorschau failure.',
        props<{
          error: MappedHttpErrorResponse<ProblemDTO>,
        }>(),
    );

    /**
     * Spiegelung des Versand-Erfolgs in den Dialog-Slice. Wird vom
     * fakturierungsbeleg-entities-Effect zusaetzlich zum `versendeBelegSuccess`
     * dispatched, damit der Dialog-OnPush-View den Sending-Zustand reaktiv
     * verarbeiten kann.
     */
    public static versendeBelegSucceeded = createAction(
        '[Senden Dialog] Versende beleg succeeded.',
    );

    /**
     * Spiegelung des Versand-Fehlers in den Dialog-Slice (Pendant zu
     * versendeBelegSucceeded). Re-aktiviert den Senden-Button, damit der
     * Nutzer erneut versuchen kann.
     */
    public static versendeBelegFailed = createAction(
        '[Senden Dialog] Versende beleg failed.',
    );

    /**
     * Wird vom Dialog-Trigger dispatched, sobald der Versand startet. Setzt
     * den `sending`-Flag im Dialog-Slice. Der eigentliche Service-Call wird
     * weiterhin ueber `FakturierungsbelegEntitiesActions.versendeBeleg`
     * angestossen — diese Action treibt nur den lokalen Dialog-State.
     */
    public static versendeBeleg = createAction(
        '[Senden Dialog] Versende beleg.',
    );
}
